import React, {Component} from "react";

import { connect } from "react-redux";



import {getActiveTournament} from "../../../modules/tournament.js";
import OnlineRoomList from "./online-room-list.js";

import TournamentDialog from "../tournaments/tournament-dialog.js";
import TournamentBanner from "../tournaments/tournament-banner.js";


class OnlineRoomPage extends Component{
    constructor(props) {
        super(props);

        this.state = {
            show_tournament_dialog: false,
            tournament_data: false
        };
    }

    async componentDidMount() {
        let {token} = this.props;
        let currentTournamentResponse = await getActiveTournament(token);

        if (currentTournamentResponse.data.success) {
            let tournamentData = currentTournamentResponse.data.tournament;
            let active = currentTournamentResponse.data.active;

            tournamentData.active = active;
            this.setState({
                tournament_data: tournamentData
            });
        }
    }


    showTournamentDialog() {
        this.setState({show_tournament_dialog: true});
    }

    hideTournamentDialog() {
        this.setState({show_tournament_dialog: false});
    }

    render() {
        let {token} = this.props;
        let {tournament_data, show_tournament_dialog} = this.state;
        return (
            <div className='tw-text-left'>
                {tournament_data && <TournamentDialog tournament_data={tournament_data} show={show_tournament_dialog} hide_func={this.hideTournamentDialog.bind(this)} token={token}/>}
                {tournament_data && <TournamentBanner tournament_data={tournament_data} show_func={this.showTournamentDialog.bind(this)}/>}
                <OnlineRoomList token={token} />
            </div>
            
        );
        
        
    }
}

const withState = connect((state)=>{
    const { user } = state;
    return{ 
        token: user.token
    }
})

export default withState(OnlineRoomPage);


// WEBPACK FOOTER //
// ./src/components/containers/online-room-list/online-room-page.js